import { FC } from "react";
import { Reporter } from "types";
import { DateView } from "utils/helper";

type Props = {
  reporter: Reporter | undefined;
  isOpen: boolean;
  onClose: () => void;
};

const ReporterDetail: FC<Props> = ({ reporter, isOpen, onClose }) => {
  const handleClickOutside = (e: any) => {
    if (e.target.classList.contains("fixed")) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div
      style={{ marginTop: "0px" }}
      className="fixed inset-0 z-50 flex justify-end bg-black bg-opacity-50 backdrop-blur-sm p-4"
      onClick={handleClickOutside}
    >
      <div className="relative w-full max-w-2xl bg-white p-8 shadow-lg rounded-lg overflow-y-auto">
        <div className="text-base font-semibold text-white bg-[#212121] p-3 inline-block rounded-md">
          Suspect ID &nbsp;&nbsp; : &nbsp;&nbsp;
          {reporter?.identity_card_number}
        </div>

        <br />

        <div className="flex flex-row gap-4 mt-3 items-start">
          <div className="bg-[#BCBCBC66] rounded-md">
            <img
              src={
                reporter?.picture_file ||
                require("../../../../images/imageVector.png")
              }
              alt="User"
              className="w-auto h-[110px] rounded"
            />
          </div>
          <div className="flex flex-col w-[250px]">
            <div className="bg-[#9B0505] w-fit px-2 py-[2px] text-white rounded-md text-center font-medium text-sm">
              {reporter?.crimereference?.crime_reference_number}
            </div>
            <h2 className="text-[22px] font-semibold leading-7">
              {reporter?.first_name} {reporter?.middle_name}{" "}
              {reporter?.last_name}
            </h2>
            <p className="text-base font-normal text-[#8B8B8B]">
              {reporter?.phone_number}
            </p>
            <p className="text-base font-normal text-[#8B8B8B]">
              {reporter?.email}
            </p>
          </div>
        </div>

        {[
          { property: "Gender", value: reporter?.gender },
          { property: "Age", value: reporter?.age },
          { property: "Educational Level", value: reporter?.education_level },
          { property: "Job position", value: reporter?.job_position },
          { property: "Ethnicity", value: reporter?.ethnicity },
          { property: "Nationality", value: reporter?.nationality },
          { property: "Religion", value: reporter?.religion },
          {
            property: "Date of Birth",
            value: DateView(reporter?.date_of_birth),
          },
          { property: "Phone Number", value: reporter?.phone_number },
          { property: "Email", value: reporter?.email },
          {
            property: "Identity Card Number",
            value: reporter?.identity_card_number,
          },
        ]?.map((info, index) => (
          <div
            key={index}
            className="flex flex-row gap-4 mt-3 items-start justify-between border-b border-b-[#E9E9E9] pb-3"
          >
            <p className="font-normal text-base text-[#0A1D39]">
              {info?.property}
            </p>
            <p className="font-normal text-base text-[#0A1D39]">
              {typeof info?.value === "boolean" ||
              typeof info?.value === "object"
                ? info?.value ?? "-"
                : info?.value}
            </p>
          </div>
        ))}

        <div className="bg-[#F8F8F8] p-3 rounded-xl mt-5">
          <p className="font-normal text-[12px]">Reporter Detail</p>
          <p>{reporter?.report_details}</p>
        </div>

        <div className="bg-[#F8F8F8] p-3 rounded-xl mt-5">
          <p className="text-base font-semibold">Address Location</p>
          <hr className="text-[#8B8B8B] my-3 w-[50%]" />

          <div className="grid grid-cols-2 gap-2 gap-x-4 mt-4">
            {[
              { property: "Region", value: reporter?.region },
              { property: "Zone", value: reporter?.zone },
              { property: "Woreda", value: reporter?.woreda },
              { property: "Kebele", value: reporter?.kebele },
              { property: "House Number", value: reporter?.house_number },
              { property: "City", value: reporter?.city },
            ]?.map((info, index) => (
              <div key={index}>
                <p className="font-normal text-sm text-[#747171]">
                  {info.property}
                </p>
                <p className="font-semibold text-base text-[#0A1D39]">
                  {info.value}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReporterDetail;
